import MuiSkeleton, { SkeletonProps } from '@mui/material/Skeleton';

const Skeleton = (props: SkeletonProps) => {
  return <MuiSkeleton {...props} />;
};

export default Skeleton;
